import { Injectable } from '@angular/core';

import { ProfileTypes, ProfileViewAttr, UserTypes } from '../components/profile/profile.enum';
import {
  additionalProfileFieldsMetadata,
  additionalProfileFieldsWithFullAddressLocationMetadata,
  additionalProfileViewMetadata,
  baseFieldsMetadata,
  baseFieldsWithWarningMetadata,
  doctorRoleFieldsMetadata,
  individualUserFieldsMetadata,
  medStaffRoleFieldsMetadata,
  organizationRoleFieldsMetadata,
  patientRoleFieldsMetadata,
  researcherRoleFieldsMetadata,
} from '../components/profile/user-profile/edit-profile/profile-forms.metadata';
import { Attribute } from '../interfaces/form-and-field.interface';
import { MaybeUndefined } from '../utils';
import { CardType } from '../views/cards/cards.types';

@Injectable({ providedIn: 'root' })
export class FormStoreService {
  private attributesMetadata: Map<string, Attribute[]> = new Map();

  public constructor() {
    this.fillInProfileMetadataDictionary();
  }

  public get metadataList(): Map<string, Attribute[]> {
    return this.attributesMetadata;
  }

  public getMetadata(key: string): Attribute[] {
    const attributes: MaybeUndefined<Attribute[]> = this.attributesMetadata.get(key);

    if (!attributes) {
      console.error('Unknown attribute type');

      return [];
    }

    return attributes;
  }

  public fillInProfileMetadataDictionary(): void {
    this.attributesMetadata.set(ProfileTypes.ADDITIONAL, additionalProfileFieldsMetadata);
    this.attributesMetadata.set(
      ProfileTypes.ADDITIONAL_WITH_FULL_ADDRESS_LOCATION,
      additionalProfileFieldsWithFullAddressLocationMetadata,
    );
    this.attributesMetadata.set(ProfileViewAttr.ADDITIONAL, additionalProfileViewMetadata);
    this.attributesMetadata.set(ProfileTypes.MAIN, baseFieldsMetadata);
    this.attributesMetadata.set(ProfileTypes.MAIN_WITH_WARNING, baseFieldsWithWarningMetadata);
    this.attributesMetadata.set(UserTypes.INDIVIDUAL, individualUserFieldsMetadata);
    this.attributesMetadata.set(UserTypes.ORGANIZATION, organizationRoleFieldsMetadata);
    this.attributesMetadata.set(CardType.PATIENT, patientRoleFieldsMetadata);
    this.attributesMetadata.set(CardType.DOCTOR, doctorRoleFieldsMetadata);
    this.attributesMetadata.set(CardType.MED_STAFF, medStaffRoleFieldsMetadata);
    this.attributesMetadata.set(CardType.RESEARCHER, researcherRoleFieldsMetadata);
  }
}
